import React from "react";
// import my_logo from "../Images/my-logo-white.png";
import NavBar from "../../Components/Navbar";
import { Link } from "react-router-dom";
// import hcb from "../Images/thewharf.jpeg";
// import hcb1 from "../Images/53edit1.jpeg";
import prof from "../../Images/ayg-icon.jpg";
import SimilarYacht from "../../Components/SimilarYacht";
import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet";

const Flibs = () => {
  return (
    <div>
      <NavBar />
      <Helmet>
        <title>Fort Lauderdale International Boat Show!</title>

        <meta
          property="og:site_name"
          content="Americanyachtgroupinternational"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:locale" content="en_US" />
      </Helmet>
      <div
        style={{
          background:
            "radial-gradient(ellipse at 50% -50%, #6c94ff 0, #000 100%)",
          height: "100px",
        }}
      ></div>
      <section className="news-details mt-5 mb-2">
        <div className="container p-5 bg-body-tertiary">
          <div className="row mb-5">
            <div className="col-12 col-md-6 d-flex align-items-center text-primary-emphasis">
              <div>
                <p className="mb-1 fw-bold">Oct 29 - Nov 02, 2025</p>
                <h2 className="fw-bold text-uppercase">
                  Fort Lauderdale International Boat Show!
                </h2>

                {/* <p className="mb-2">
                  <i className="fa-solid fa-pen-nib" /> Hunter Lajiness
                </p> */}
                {/* <Link
                  to="..."
                  variant=""
                  className="btn gradient-c1 text-white"
                >
                  BOOK NBS APPOINTMENT<i class="fa-solid fa-angles-right"></i>
                </Link> */}
                {/* <p>
                  For more details contact us at{" "}
                  <span className="fw-bold">VIP@hcbyachts.com</span> or visit
                  our store front in Bayfront, Naples!
                </p> */}
              </div>
            </div>
            <div className="col-12 col-md-6">
              <img
                src="https://ayg.s3.us-east-2.amazonaws.com/genhotel.webp"
                alt="..."
                className="img-fluid mt-3"
              />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-12 col-md-12 ">
              <p
                style={{ textAlign: "justify" }}
                className="text-primary-emphasis fw-bold"
              >
                A SPLASH OF INSPIRATION
              </p>
              <h6 className="text-primary-emphasis">
                Owned by the Marine Industries Association of South Florida and
                Produced by Informa Markets, the Fort Lauderdale International
                Boat Show is the Largest In-Water Boat Show in the World.
              </h6>
            </div>
          </div>

          <p
            style={{ textAlign: "justify" }}
            className="text-primary-emphasis"
          ></p>
          <div className="row mb-5">
            <div className="col-12 col-md-6">
              <img
                src="https://ayg.s3.us-east-2.amazonaws.com/MIBS_2.jpg"
                alt="..."
                className="img-fluid mt-3"
              />
            </div>
            <div className="col-12 col-md-6 d-flex align-items-center">
              <div>
                <p
                  style={{ textAlign: "justify" }}
                  className="text-primary-emphasis"
                >
                  Experience the largest in-water boat show in the world, taking
                  place Oct 29-Nov 2, 2025. This annual event showcases more
                  world and U.S. debuts than any other boat show in the country.
                </p>
                <p
                  style={{ textAlign: "justify" }}
                  className="text-primary-emphasis pt-2"
                >
                  The 2024 Fort Lauderdale International Boat Show was a mega
                  success; returning with all seven show locations including
                  Bahia Mar Yachting Center, Broward County Convention Center,
                  Hall Of Fame Marina, Las Olas Marina, Hilton Fort Lauderdale
                  Marina, Pier Sixty-Six Marina, and Superyacht Village at Pier
                  Sixty-Six South.
                </p>
                <p
                  style={{ textAlign: "justify" }}
                  className="text-primary-emphasis pt-2"
                >
                  The five-day show attracted over 100,000 attendees and 1,000
                  exhibitors, with more than 1,300 vessels on display.
                </p>
              </div>
            </div>

            {/* <p
              style={{ textAlign: "justify" }}
              className="text-primary-emphasis pt-3"
            >
              Stop by our booth, climb aboard our world class center console
              yachts, and experience the next level of luxury and innovation.
              See you there!
            </p> */}
            <p
              style={{ textAlign: "justify" }}
              className="text-primary-emphasis"
            >
              We look forward to seeing you there!
            </p>
          </div>
        </div>
      </section>
      {/*Similar Yachts For Sale */}
      <section className="mb-4">
        <Container fluid className="col-lg-11">
          <h4 className="fw-bold text-primary-emphasis">
            Other HCB Yachts For Sale
          </h4>
          <hr />
          <SimilarYacht />
        </Container>
      </section>
    </div>
  );
};

export default Flibs;
